<div class="header">
  <h2>{{ 'forms:digitalSignature' | i18nextCap }}</h2>
  <button
    mat-icon-button
    type="button"
    aria-label="Close"
    class="close-btn"
    (click)="onClickCancel()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="content">
  <fo-signature-pad (changeEvent)="onSignatureChange($event)" />
  <mat-form-field>
    <mat-label>{{ 'comment' | i18nextCap }}</mat-label>
    <textarea matInput [formControl]="commentField" rows="6"></textarea>
  </mat-form-field>
  <div class="actions">
    <button
      mat-flat-button
      color="primary"
      [disabled]="signature == null"
      (click)="onClickSign()"
    >
      {{ 'forms:generate' | i18nextCap }}
    </button>
  </div>
</div>
